<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (tap)="cancelContract()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Contract And Collection</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content #content>
    <datepicker [document]="documentTemp"></datepicker>
    <customer [document]="documentTemp"></customer>
    <site [document]="documentTemp"></site>
    <items *ngIf="documentTemp.customer.name" [document]="documentTemp"></items>
    <patient-info [document]="documentTemp"></patient-info>
    <comments [document]="documentTemp"></comments>

    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button (tap)="saveContract()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>

</ion-content>


